export { default as Input } from './Input';
export type { InputProps } from './Input';
